import React from "react";
import { useSelector } from "react-redux";
import ReactTooltip from "react-tooltip"; // Custom Components

import * as AppAction from "../../../store/actions/app.action"; // Styles

import "./title.styles.scss";

function Title() {
  const filename = useSelector(state => state.appReducer[AppAction.PDF_FILENAME]);
  if (!filename) return "...";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReactTooltip, null), /*#__PURE__*/React.createElement("div", {
    "data-tip": filename,
    className: "react__pdf--title"
  }, /*#__PURE__*/React.createElement("span", null, filename)));
}

export default Title;